<template>
    <div ref="container">
       <a-modal 
        :title="title" 
        width="95%" 
        :visible="visible" 
        :confirmLoading="confirmLoading" 
        :maskStyle="{'top':'93px','left':'154px'}" 
        :maskClosable="false" 
        @ok="handleOk" 
        @cancel="handleCancel"
        @closeModal="closeModal" 
        cancelText="关闭" 
        style="top:50px;height: 90%;"
        >
          
          <a-row>
            <a-col :md="10" :sm="24">
            <template>
              <a-dropdown :trigger="[this.dropTrigger]" @visibleChange="dropStatus">
               <span style="user-select: none">
                <a-tree
                  checkable
                  multiple
                  @select="onSelect"
                  @check="onCheck"
                  @rightClick="rightHandle"
                  :selectedKeys="selectedKeys"
                  :checkedKeys="checkedKeys"
                  :treeData="categoryTree"
                  :checkStrictly="checkStrictly"
                  :expandedKeys="iExpandedKeys"
                  :autoExpandParent="true"
                  @expand="onExpand"/>
                </span>
              </a-dropdown>
            </template>
          </a-col>
          </a-row>
        </a-modal>
    </div>
</template>
<script>
// import pick from 'lodash.pick'
// import process from '@/views/trace/process';
import { queryMaterialCategoryTreeList, queryMaterialCategoryById, bindingCategory, queryCategoryByCraftId } from '@/api/api'
export default {
  name: 'CustomerModal',
  components: {
    // process
  },
  data () {
    return {
      title: '选择类别',
      visible: false, 
      confirmLoading: false,
      traceVueModule: null,
      form: this.$form.createForm(this),
      draggedItem: null,
      draggedFrom: null,
      model: {},
      categoryTree: [],
      iExpandedKeys: [],
      checkStrictly: false,
      checkedKeys: [],
      dropTrigger: '',
      selectedKeys: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
      },
      formModule:[],
      traceModuleForm: {},
      getCraftFromFather: ''
    }
  },
    methods: {
        open(data){
            this.visible = true
            this.getCraftFromFather = data
            this.getCategoryTreeList()
            this.queryCategoryByCraftId()
        },
        // 获取品类列表
        async getCategoryTreeList(){
          const params = {
            id : this.getCraftFromFather.id
          }
          const res = await queryMaterialCategoryTreeList(params)
          console.log(res,'类别列表============')
          if (res) {
            //类别全选后，再添加类别，选中数量增多
            this.allTreeKeys = [];
            for (let i = 0; i < res.length; i++) {
              let temp = res[i]
              // 查看列表是否存在该节点，如果存在则不添加
              if (this.categoryTree.some(item => item.key === temp.key)) {
                continue
              } else {
                this.categoryTree.push(temp)
              }
              
              this.setThisExpandedKeys(temp)
              this.getAllKeys(temp);
            }
            this.loading = false
          }
        },
        // 获取绑定的类别
        async queryCategoryByCraftId(){
          const params = {
            craftId : this.getCraftFromFather.id
          }
          const res = await queryCategoryByCraftId(params)
          if( res.code == 200 && res.success == true ){
            console.log(res,'类别绑定列表888888888888============')
            if( res.result.length > 0 ){
              for (let i = 0; i < res.result.length; i++) {
                let temp = res.result[i]
                this.checkedKeys.push(temp.materialCategoryId)
                console.log(this.checkedKeys,'checkedKeys============================')
              }
            }
          }

        },
        setThisExpandedKeys(node) {
          if (node.children && node.children.length > 0) {
            this.iExpandedKeys.push(node.key)
            for (let a = 0; a < node.children.length; a++) {
              this.setThisExpandedKeys(node.children[a])
            }
          }
        },
        getAllKeys(node) {
          // console.log('node',node);
          this.allTreeKeys.push(node.key)
          if (node.children && node.children.length > 0) {
            for (let a = 0; a < node.children.length; a++) {
              this.getAllKeys(node.children[a])
            }
          }
        },
        // 右键点击下拉框改变事件
        dropStatus(visible) {
          if (visible == false) {
            this.dropTrigger = ''
          }
        },
        onCheck(checkedKeys, info) {
          // 获取选中的checkbox
          console.log('Checked keys:', checkedKeys);
          console.log('Check info:', info);

          // 更新 checkedKeys
          this.checkedKeys = checkedKeys;

          // 获取选中的节点对象
          const checkedNodes = info.checkedNodes;
          console.log('Checked nodes:', checkedNodes);

          // 获取半勾选的节点键数组
          const halfCheckedKeys = info.halfCheckedKeys;
          console.log('Half checked keys:', halfCheckedKeys);

        },
        // 右键操作方法
        rightHandle(node) {
          this.dropTrigger = 'contextmenu'
          console.log(node.node.eventKey)
          this.rightClickSelectedKey = node.node.eventKey
          this.rightClickSelectedOrgCode = node.node.dataRef.orgCode
        },
        onExpand(expandedKeys) {
          console.log('onExpand', expandedKeys)
          this.iExpandedKeys = expandedKeys
        },
        onSelect(selectedKeys, e) {
          console.log('selected', selectedKeys, e)
          this.hiding = false
          let record = e.node.dataRef
          let params = {};
          params.id=record.id;
          // this.getTreeByParams(params)
          // queryMaterialCategoryById(params).then((res) => {
          //   if (res && res.code == 200) {
          //     if(res.data){
          //       record.name = res.data.name;
          //       record.serialNo = res.data.serialNo;
          //       record.parentId = res.data.parentId;
          //       record.sort = res.data.sort;
          //       record.remark = res.data.remark;
          //       console.log('onSelect-record', record)
          //       this.currSelected = Object.assign({}, record)
          //       this.model = this.currSelected
          //       this.selectedKeys = [record.key]
          //       this.model.parentId = record.parentId
          //       this.setValuesToForm(record)
          //     }
          //   }
          // })
        },
        // 右键点击下拉框改变事件
        dropStatus(visible) {
          if (visible == false) {
            this.dropTrigger = ''
          }
        },
        // 右键店家下拉关闭下拉框
        closeDrop() {
          this.dropTrigger = ''
        },
        show(data){
            this.traceVueModule = data
        },
        async handleOk() {
          console.log(this.checkedKeys,'this.checkedKeys======')
          const list = this.checkedKeys.map(key => ({
            craftId: this.getCraftFromFather.id,
            materialCategoryId: key
          }));
          const params = {
            list: list,
            craftId: this.getCraftFromFather.id
          }
          const res = await bindingCategory(params)
          if( res.code == 200 && res.success == true ){
            this.visible = false;
            this.$message.success(res.message);
            this.checkedKeys = [];
          }
          
        },
        handleCancel(){
          this.visible = false;
          this.resetCurrentStepInChild();
          this.checkedKeys = [];
        },
        closeModal(){
          this.visible = false;
          this.checkedKeys = [];
        },
        resetCurrentStepInChild() {
          if (this.$refs.traceCode) {
            this.$refs.traceCode.resetCurrentStep();
          }
        }
    }
}
</script>
<style lang="less" scoped>
  .processBox{
    display: flex;
    justify-content: space-between;
    .ant-col{
      height: 100%;
      width: 48%;
      border: 1px solid #ededed;
      border-radius: 5px;
      padding: 10px;
    }
    .processFlowList {
      justify-content: flex-start;
      span {
        margin-right: 10px;
      }
    }
  }
</style>